export default "__VITE_ASSET__CUiEtLix__"